import type { HoppModule } from "@hoppscotch/common/modules"

import { def as auth } from "@app/platform/auth/web"

/**
 * Redirects unauthenticated users to Microsoft SSO before the app renders.
 * Only active in web (non-desktop) mode.
 */
export const authRequiredModule: HoppModule = {
  onRouterInit(_app, router) {
    // createHoppApp awaits authentication before installing the router.
    // Read the completed state; its login/logout event has already fired.
    const isAuthenticated = auth.getCurrentUser() !== null

    router.beforeEach(() => {
      if (!isAuthenticated) {
        // Kick off Microsoft SSO; after login the backend redirects back to VITE_BASE_URL
        window.location.href = `${
          import.meta.env.VITE_BACKEND_API_URL
        }/auth/microsoft?redirect_uri=${encodeURIComponent(
          import.meta.env.VITE_BASE_URL
        )}`
        return false
      }
    })
  },
}
